import styled from 'styled-components';

export const QuestionContainer = styled.div`
  display: flex;
  border: 1px solid #ff780c;
  border-radius: 15px;
  width: 100%;
  min-height: 3.5rem;
  align-items: center;
  padding: 0.75rem 1.3rem;
  gap: 0.75rem;
  background-color: #ffffff;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08),
    0 1.5px 4px 0 rgba(0, 0, 0, 0.05);

  break-inside: avoid;
  page-break-inside: avoid;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const TitleField = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

export const Text = styled.span`
  word-break: break-word;
  white-space: pre-line;
  overflow-wrap: break-word;
  display: block;
  font-family: 'Roboto', sans-serif;
  font-size: clamp(11px, 0.9vw, 14px);
`;

export const OptionField = styled.div`
  display: flex;
  min-width: 200px;
  max-width: 35%;
  border-radius: 999px;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 1rem;
  min-height: 2rem;
  background-color: #ff780c;

  span {
    color: #ffffff;
    font-weight: 600;
    text-align: center;
  }

  @media (max-width: 600px) {
    max-width: 100%;
    width: 100%;
  }
`;
